// One tooltip look for the whole app, replacing MUI's default grey slab.
//
// The surface stays dark in both modes: a tooltip is an annotation floating
// over the page, and a light bubble on a light page needs a border to read as
// separate at all. Only the depth changes between modes.
export const MuiTooltip = {
  defaultProps: {
    arrow: true,
    enterDelay: 200,
    enterNextDelay: 200,
    leaveDelay: 0,
  },
  styleOverrides: {
    tooltip: {
      backgroundColor: '#0b3a34',
      color: '#eef7f4',
      maxWidth: 280,
      padding: '9px 12px',
      borderRadius: '8px',
      border: '1px solid rgba(95, 224, 173, 0.25)',
      boxShadow:
        '0 2px 6px rgba(4, 24, 21, 0.35), 0 12px 28px rgba(4, 24, 21, 0.28)',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: 1.5,
      letterSpacing: '0.01em',
    },
    arrow: {
      color: '#0b3a34',
      // Keeps the pointer's outline in step with the bubble's border.
      '&::before': { border: '1px solid rgba(95, 224, 173, 0.25)' },
    },
  },
}
